
import { mapCollection } from '../../utils/collection.utils';
import { CompanyWithResearchUnits } from '../company-with-research-group';
import { ResearchUnitBuilder } from './research-unit.builder';

export class CompanyWithResearchUnitBuilder {
  static fromJson(json) {
    return (json)
      ? new CompanyWithResearchUnits(
        json.hash,
        json.commercialName,
        json.businessName,
        json.taxNumber,
        ResearchUnitBuilder.fromList(json.researchUnits)
      )
      : null;
  }

  static fromList(list) {
    return (Array.isArray(list)) ? mapCollection(CompanyWithResearchUnitBuilder.fromJson, list) : [];
  }
}
